export enum ChartDataFormat {
    VIS = 'VIS',
    ECHARTS = 'ECHARTS',
    PLOTLY = 'PLOTLY',
    HTML = 'HTML',
}
